import { StyleSheet, Platform } from 'react-native'
import theme from '../../../theme'

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
        // En web evitamos centrar para permitir que el grid de columnas maneje el ancho
        alignItems: Platform.OS === 'web' ? 'flex-start' : 'center',
        justifyContent: 'flex-start',
        paddingHorizontal: 20,
    },
    title: {
        fontSize: 16,
        fontWeight: 'bold',
        marginBottom: 15,
        color: theme.colors.textPrimary,
    },
    commentsBlock: {
        flex: 1,
        width: '100%',
        borderRadius: 10,
        marginBottom: 10,
    },
    replyToContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 10,
        justifyContent: 'space-between',
    },
    replyToText: {
        fontSize: 13,
        fontWeight: 'normal',
        color: theme.colors.darkGray,
        marginHorizontal: 15,
    },
    clearButton: {
        paddingHorizontal: 15,
        paddingVertical: 5,
    },
    inputBlock: {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 15,
        marginBottom: 25,
    },
    input: {
        height: 35,
        borderWidth: 0.5,
        marginRight: 10,
        paddingHorizontal: 10,
        paddingVertical: 2,
        borderRadius: 10,
        borderColor: theme.colors.mediumGray,
        backgroundColor: 'white',
        width: '100%',
        color: theme.colors.textPrimary,
        alignContent: 'center',
        alignItems: 'center',
    },
    iconSend: {
        width: 25,
        height: 25,
    },
    containerNoComments: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    imageNoComments: {
        width: 120,
        height: 120,
    },
    titleNoComments: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
        marginTop: 10,
        paddingHorizontal: 0,
    },
    descriptionNoComments: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingHorizontal: 50,
        paddingBottom: 20,
    },
    containerPost: {
        flex: 1,
        width: Platform.OS === 'web' ? '98%' : '100%',
        backgroundColor: 'white',
        paddingBottom: 20,
        paddingTop: 10,
        // Asegurar que dentro del post el contenido se estire en web
        alignItems: Platform.OS === 'web' ? 'stretch' : undefined,
        overflow: Platform.OS === 'web' ? 'hidden' : 'visible',
    },
    commentsHeader: {
        paddingHorizontal: 15,
        width: '100%',
        paddingVertical: 10,
        borderBottomWidth: 1,
        borderBottomColor: theme.colors.extraLightGray,
        alignItems: 'center',
        marginBottom: 10,
    },
    commentInputContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        padding: 10,
        borderTopWidth: 1,
        borderTopColor: theme.colors.colorBorder || '#e0e0e0',
        backgroundColor: 'white',
    },
    inputComment: {
        flex: 1,
        borderWidth: 1,
        borderColor: theme.colors.colorBorder || '#e0e0e0',
        borderRadius: 20,
        paddingHorizontal: 15,
        paddingVertical: 8,
        marginRight: 10,
        fontSize: 14,
        color: theme.colors.colorText || '#000',
        maxHeight: 100,
    },
    closeReplyButton: {
        position: 'absolute',
        right: 60,
        padding: 5,
    },
    sendButton: {
        width: 40,
        height: 40,
        borderRadius: 20,
        backgroundColor: theme.colors.colorPrimary,
        justifyContent: 'center',
        alignItems: 'center',
    },
    sendButtonDisabled: {
        backgroundColor: theme.colors.colorDisabled || '#ccc',
    },
})
export default styles
